// extracted by mini-css-extract-plugin
module.exports = {"clientName":"JobClientDetails_clientName__eCc__"};